document.querySelectorAll('[data-mintoss-editorial]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  root.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=>{
    root.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    let count=0;
    root.querySelectorAll('[data-category]').forEach(card=>{card.hidden=button.dataset.filter!=='All'&&card.dataset.category!==button.dataset.filter;if(!card.hidden)count++;});
    const status=root.querySelector('[data-filter-status]');if(status)status.textContent=count+' articles shown';
  }));
});
document.querySelectorAll('[data-mintoss-toc]').forEach(toc=>{
  const body=toc.closest('.me-story').querySelector('.me-body');
  body.querySelectorAll('h2[id]').forEach(h=>{const a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;toc.append(a);});
});
